import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import { router } from './router';
import { injectIconSprite } from './shared/icon/sprite';
import { useAuthStore } from './stores/auth';
import { useUiStore } from './stores/ui';
import { useSyncStore } from './stores/sync';
import { useTasksStore } from './stores/tasks';
import { useMembersStore } from './stores/members';

import './assets/styles/app.css';
import './assets/styles/base.css';

async function bootstrap() {
  injectIconSprite();

  const app = createApp(App);
  const pinia = createPinia();
  app.use(pinia);

  const auth = useAuthStore();
  auth.installBridge();

  const ui = useUiStore();
  await ui.init();

  await auth.restore();
  ui.setChildMode(auth.isChild);

  const sync = useSyncStore();
  await sync.init(() => void useTasksStore().drainOutbox());

  if (auth.isAuthenticated) {
    await useTasksStore().bootstrap();
    void useMembersStore().load();
  }

  app.use(router);
  app.mount('#app');
}

void bootstrap();
